import { render, staticRenderFns } from "./patYundan.vue?vue&type=template&id=1d3622a8&scoped=true"
import script from "./patYundan.vue?vue&type=script&lang=js"
export * from "./patYundan.vue?vue&type=script&lang=js"
import style0 from "./patYundan.vue?vue&type=style&index=0&id=1d3622a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3622a8",
  null
  
)

export default component.exports